import { render } from "./flash.vue?vue&type=template&id=651ce37d"
import script from "./flash.js?vue&type=script&lang=js"
export * from "./flash.js?vue&type=script&lang=js"

import "./flash.vue?vue&type=style&index=0&id=651ce37d&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__